import gql from 'graphql-tag';

export default gql`
  fragment preleadProjectGroupCustomizeItemSelectOptionFragment on PreleadProjectGroupCustomizeItemSelectOption {
    id
    projectGroupPreleadCustomizeItemSelectOptionId
  }
`;
